import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { unSetUserToken } from '../features/authSlice';
import { unsetUserInfo } from '../features/userSlice';
import { getToken, removeToken } from '../services/LocalStorageService';
import { useLogoutUserMutation } from '../services/userAuthApi';

const Logout = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [logoutUser] = useLogoutUserMutation()

    useEffect(() => {
      const { refresh_token } = getToken()

      const performLogout = async () => {
        if (refresh_token) {
          // Best-effort: invalidate the refresh token server-side so it can't
          // be replayed. Local state is cleared regardless of the result.
          try {
            await logoutUser(refresh_token).unwrap()
          } catch (e) {
            // token may already be expired/blacklisted - not fatal to logout
          }
        }
        dispatch(unsetUserInfo({ first_Name: "", last_Name: "", email: "", type: "" }))
        dispatch(unSetUserToken({ access_token: null }))
        removeToken()
        navigate("/login")
      }

      performLogout()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null
};

export default Logout;
